var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn",class:_vm.btnClass},_vm.$listeners),[_c('Miniloader'),_c('span',{staticClass:"btn-text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }